/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SystemNotification { 
    status: SystemNotification.StatusEnum;
    notificationType: SystemNotification.NotificationTypeEnum;
    id?: number;
    from: string;
    to: string;
    messageDe: string;
    messageFr: string;
    messageIt: string;
}
export namespace SystemNotification {
    export type StatusEnum = 'ERROR' | 'WARNING';
    export const StatusEnum = {
        ERROR: 'ERROR' as StatusEnum,
        WARNING: 'WARNING' as StatusEnum
    };
    export type NotificationTypeEnum = 'TECHNICAL_ISSUE' | 'MAINTENANCE' | 'MAINTENANCE_NOW' | 'LIMITED_FUNCTIONS' | 'INDIVIDUAL';
    export const NotificationTypeEnum = {
        TECHNICAL_ISSUE: 'TECHNICAL_ISSUE' as NotificationTypeEnum,
        MAINTENANCE: 'MAINTENANCE' as NotificationTypeEnum,
        MAINTENANCE_NOW: 'MAINTENANCE_NOW' as NotificationTypeEnum,
        LIMITED_FUNCTIONS: 'LIMITED_FUNCTIONS' as NotificationTypeEnum,
        INDIVIDUAL: 'INDIVIDUAL' as NotificationTypeEnum
    };
}


